import { z } from '../utils/zod.js';
import { dataResponse, listResponse, successResponse } from '../utils/response-templates.js';
export const STAFF_NOTE_ENTITIES = ['USER', 'ORGANIZATION', 'SIGNING'];
export const staffNoteEntitySchema = z.enum(STAFF_NOTE_ENTITIES);
export const STAFF_NOTE_MAX_LENGTH = 4000;
const noteBodySchema = z.string().trim().min(1).max(STAFF_NOTE_MAX_LENGTH);
export const staffNoteAuthorSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string(),
});
export const staffNoteDtoSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    entityType: staffNoteEntitySchema,
    entityId: z.string().uuid(),
    body: z.string(),
    pinned: z.boolean(),
    author: staffNoteAuthorSchema,
});
export const staffNoteIdParamsSchema = z.object({
    noteId: z.string().uuid(),
});
export const listStaffNotesQuerySchema = z.object({
    entityType: staffNoteEntitySchema,
    entityId: z.string().uuid(),
});
export const createStaffNoteRequestSchema = z.object({
    entityType: staffNoteEntitySchema,
    entityId: z.string().uuid(),
    body: noteBodySchema,
});
export const updateStaffNoteRequestSchema = z
    .object({
    body: noteBodySchema.optional(),
    pinned: z.boolean().optional(),
})
    .refine((body) => body.body !== undefined || body.pinned !== undefined, {
    message: 'Provide body and/or pinned',
    path: ['body'],
});
export const staffNoteResponseSchema = dataResponse(staffNoteDtoSchema);
export const listStaffNotesResponseSchema = listResponse(staffNoteDtoSchema);
export const deleteStaffNoteResponseSchema = successResponse();
